export enum SocketRoutes {
  ENTER = 'creatives/enter',
  LEAVE = 'creatives/leave',
  EXPORT_CANVAS = 'creatives/exports/canvas'
}

export interface ISocketSendMessage {
  route: SocketRoutes,
  creativeId: string;
}
